module.exports = __webpack_public_path__ + "img/icon6.0aa3e81c.png";